import React, { useEffect, useState } from "react";
import { Modal, Table, Pagination } from "antd";
// import { remainingViewportHeight } from "../../../components/icons/ApplicationColor";
import { useSelector } from "react-redux";
import axiosInstance from "../../../api/Axios";

const CatSubCatCourseModal = ({
  selectedRecord,
  isModalVisible,
  handleModalClose,
  from = "cat",
}) => {
  console.log(selectedRecord);
  const userInfo = useSelector((state) => state.user);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [itemsLength, setItemsLength] = useState();
  const passText = from === "cat" ? "category" : "producer";
  const [filterData, setFilterData] = useState({
    pageSize: 5,
    currentPage: 1,
    url: `/courselist/?organization=${userInfo?.data?.organization?.id}`,
    search: "",
    active: true,
    filter_url: "",
  });
  const { pageSize, currentPage, url, active } = filterData;
  const LoadUser = async (id) => {
    console.log("lol");
    let passUrl = url;

    passUrl += `&${passText}=${id}&page=${currentPage}&page_size=${pageSize}&status=${
      active ? "True" : "False"
    }`;

    setLoading(true);
    try {
      const res = await axiosInstance.get(passUrl);
      setData(res.data.results);
      setItemsLength(res.data.count);
      setLoading(false);
      //console.log(data);
    } catch (err) {
      //console.log(err);
    }
  };
  const columns = [
    {
      title: "Course ID",
      dataIndex: "course_id",
      key: "course_id",
      fixed: "left",
      width: 120,
    },
    {
      title: "Course Title",
      dataIndex: "name",
      key: "name",
      fixed: "left",
      width: 200,
    },
    { title: "Category", dataIndex: "category", key: "category", width: 160 },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      ellipsis: true,
      width: 250,
    },
    { title: "Provider", dataIndex: "provider", key: "provider", width: 120 },
    { title: "Course Type", dataIndex: "mode", key: "mode", width: 120 },

    { title: "Language", dataIndex: "language", key: "language", width: 120 },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      width: 120,
      render: (text, record) => {
        console.log("Change");
        const date = new Date(text);
        const month = date
          .toLocaleString("default", { month: "short" });
        const day = date.getDate();
        const year = date.getFullYear();
        const formattedDate = `${month}-${day < 10 ? "0" + day : day}-${year}`;
        return formattedDate;
      },
    },
  ];
  const onShowSizeChange = (current, size) => {
    setFilterData((prevData) => ({
      ...prevData,
      pageSize: size,
    }));
  };

  const onPageChange = (page, pageSize) => {
    setFilterData((prevData) => ({
      ...prevData,
      currentPage: page,
    }));
  };
  useEffect(() => {
    if (selectedRecord) {
      LoadUser(selectedRecord);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterData, selectedRecord]);
  return (
    <Modal
      title="Associated Courses"
      width={1100}
      centered
      open={isModalVisible}
      onCancel={handleModalClose}
      footer={null}
    >
      <Table
        columns={columns}
        dataSource={data}
        loading={loading}
        size="small"
        bordered
        rowKey="id"
        className="table-container"
        scroll={{
          x: 1000,
          y: 500,
        }}
        style={{ marginInline: "1rem" }}
        pagination={false}
      />
      <div
        style={{
          display: "flex",
          justifyContent: "flex-end",
          padding: "1rem",
        }}
      >
        <Pagination
          size="small"
          showSizeChanger
          onShowSizeChange={onShowSizeChange}
          onChange={onPageChange}
          pageSizeOptions={["5", "10", "30", "50", "100"]}
          showQuickJumper
          current={currentPage}
          defaultPageSize={pageSize}
          total={itemsLength}
        />
      </div>
    </Modal>
  );
};

export default CatSubCatCourseModal;
